import React, { useRef, useState, Component } from 'react'
import { connect } from 'react-redux'
import { createEntity } from '../../store/actions/entityActions'
import firebase from "firebase/compat/app";
import 'firebase/compat/firestore'
import { useNavigate } from 'react-router-dom';
import { styles } from '../layout/styles'
import { Button, Card, CardBody, Table, Modal } from 'react-bootstrap'
import { grey } from '../../config/Colors';

function CreateEntity (props) {
    const navigate = useNavigate();
    const firstnameRef = useRef()
    const lastnameRef = useRef()
    const genderRef = useRef()
    const dateofbirthRef = useRef()
    const heightRef = useRef()
    const weightRef = useRef()

    const [showMsg, setshowMsg] = useState(false);
    const handleCloseMsg = () => {setshowMsg(false); navigate('/');}
    function handleShowMsg() {
        console.log(showMsg);
        setshowMsg(true); 
        console.log(showMsg);
        // navigate('/');
    };

    const state = {
        id:-1,
        firstname: '',
        lastname:'',
        gender:'',
        dateofbirth: new Date(),
        height:-1,
        weight:-1,
        profileimageurl:'',
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (dateofbirthRef.current.value == '') {
            var defaultDate = new Date().toISOString().split("T")[0];
            dateofbirthRef.current.value = defaultDate;
        }

        const pState = {
            id:-1,
            firstname: firstnameRef.current.value,
            lastname: lastnameRef.current.value,
            gender: genderRef.current.value,
            dateofbirth: firebase.firestore.Timestamp.fromDate(new Date(dateofbirthRef.current.value)),
            height: heightRef.current.value,
            weight: weightRef.current.value,    
            profileimageurl:'',
        }

        console.log(pState);
        props.createEntity(pState)
        handleShowMsg();
        // navigate('/');
    }

    return (
        <div style={styles.MainBGDivNoAlign}>
            <div style={styles.DashboardContainer}>

            <Modal style={{background:'transparent'}} show={showMsg} backdrop="static" size="sm" aria-labelledby="contained-modal-title-vcenter" centered onHide={handleCloseMsg}>
                <Modal.Header closeButton>
                <Modal.Title>Message</Modal.Title>
                </Modal.Header>
                <Modal.Body>Profile created successfully!</Modal.Body>
                <Modal.Footer>
                <Button variant="primary" onClick={handleCloseMsg}>
                    Close
                </Button>
                </Modal.Footer>
            </Modal>

            <form onSubmit={handleSubmit}>
            <Card className="text-left">
                        <Card.Header className='text-center'> 
                            <Card.Title>
                                <div>
                                    <Table responsive="sm">
                                        <tbody>
                                        <tr>
                                            <td style={{textAlign:'left', width:'60%'}}><h3 style={styles.SubHeader}>Create Child's Profile</h3></td>
                                            <td style={{textAlign:'right', width:'15%'}}><Button type='submit' style={styles.CDButton50}>Save</Button></td>
                                            <td style={{textAlign:'center', width:'15%'}}><Button style={styles.CDButton50} onClick={() => navigate("/")}>Cancel</Button></td>
                                        </tr>
                                        </tbody>
                                    </Table>                            
                                </div>
                            </Card.Title>
                        </Card.Header>                   
                        <CardBody>
                            <div>    
                                <Table responsive="sm">
                                    <tbody>
                                    <tr>
                                        <td style={{textAlign:'left', width:'50%'}}>
                                            <div className='imput-field'>
                                                <label htmlFor="firstname">First Name</label>
                                                <input id="firstname" type="text" ref={firstnameRef} />
                                            </div>
                                        </td>
                                        <td style={{textAlign:'left', width:'50%'}}>
                                            <div className='imput-field'>
                                                <label htmlFor="lastname">Last Name</label>
                                                <input id="lastname" type="text" ref={lastnameRef} />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign:'left', width:'50%'}}>
                                        <div className='imput-field'>
                                            <label>Gender</label>
                                                <select id="gender" class="browser-default" defaultValue="" ref={genderRef} >
                                                    <option value="" disabled >Choose your option</option>
                                                    <option value="M">Male</option>
                                                    <option value="F">Female</option>
                                                    <option value="N">Choose not to share</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td style={{textAlign:'left', width:'50%'}}>
                                            <div className='imput-field'>
                                                <label htmlFor="dateofbirth">Date of Birth</label>
                                                <input id="dateofbirth" type="date" ref={dateofbirthRef}/>
                                            </div>                    
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign:'left', width:'50%'}}>
                                            <div className='imput-field'>
                                                <label htmlFor="height">Height</label>
                                                <input id="height" type="number" ref={heightRef}/>  
                                            </div>
                                        </td>
                                        <td style={{textAlign:'left', width:'50%'}}>
                                            <div className='imput-field'>
                                                <label htmlFor="weight">Weight</label>
                                                <input id="weight" type="number" ref={weightRef}/>
                                            </div>                                            
                                        </td>
                                    </tr>
                                    </tbody>
                                </Table>                            
                            </div>

                        </CardBody>
                        <Card.Footer className="text-right">
                        </Card.Footer>
                </Card>




{/* 
                <Card style={{width:'100%', backgroundColor:'transparent'}}>
                    <CardBody>
                            <div style={{ width:'400px', margin:'auto', padding: "20px 20px", }}>
                                <h2 style={styles.SubHeader}>Create child's profile</h2>
                            </div>    
                            <div className='imput-field'>
                                <label htmlFor="lastname">Last Name</label>
                                <input id="lastname" type="text" ref={lastnameRef} />
                            </div>
                            <div className='imput-field'>
                            <label>Gender</label>
                                <select id="gender" class="browser-default" defaultValue="" ref={genderRef} >
                                    <option value="" disabled >Choose your option</option>
                                    <option value="M">Male</option>
                                    <option value="F">Female</option>
                                    <option value="N">Choose not to share</option>
                                </select>
                            </div>
                            <div className='imput-field'>
                                <label htmlFor="dateofbirth">Date of Birth</label>
                                <input id="dateofbirth" type="date" ref={dateofbirthRef}/>
                            </div>
                            <div className='imput-field'>
                                <label htmlFor="height">Height</label>
                                <input id="height" type="number" ref={heightRef}/>
                            </div>
                            <div className='imput-field'>
                                <label htmlFor="weight">Weight</label>
                                <input id="weight" type="number" ref={weightRef}/>
                            </div>
                            <div style={{ width:'200px', margin:'auto', padding: "20px 20px", }}>
                                <p><Button style={styles.CDFullButton}>Save</Button></p>
                                <p><Button style={styles.CDFullButton} onClick={() => navigate("/")}>Cancel</Button></p>
                            </div>
                </CardBody>
            </Card> */}


            </form>
            </div>
        </div>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        createEntity: (entity) => dispatch(createEntity(entity))
    }
}

export default connect(null, mapDispatchToProps)(CreateEntity)

